export const convertDate = (arr: Array<number>): Date => {
    const [year, dayOfYear, , hour, minute, nanoseconds] = arr;

    // Create a date in UTC using Date.UTC
    // This preserves the day value correctly across timezones
    const utcTimestamp = Date.UTC(
        year,
        0, // January
        1 + dayOfYear - 1, // Adjust for day of year
        hour % 24, // Normalize hours in case they exceed 24
        minute,
        0,
        nanoseconds / 1e6
    );

    return new Date(utcTimestamp);
}

// Format a date to display only day/month/year
export const formatDateShort = (date: Date): string => {
    return date.toLocaleDateString(undefined, {
        year: 'numeric', 
        month: 'numeric', 
        day: 'numeric'
    });
}

// Convert dates to YYYY-MM-DD format expected by the backend
// Ref: parse_date_to_offsetdatetime uses [year]-[month]-[day] format
export const formatDate = (date: Date): string => {
    const year = date.getFullYear();
    // getMonth() returns 0-11, so add 1 and use padStart to get 01-12
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
};